<template>
  <div class="onlineSetting">
    <el-dialog
      title="网诊设置"
      :visible.sync="visible"
      width="430px"
      :before-close="close">
      <div class="content">
        <div
          v-for="item in optionList"
          :key="item.value"
          class="option-card"
          :class="{ active: mode === item.value }"
          @click="modeChange(item.value)">
          <div class="option-body">
            <div class="option-title">{{ item.title }}</div>
            <div class="option-desc">{{ item.desc }}</div>
            <div v-if="item.value === 2 && mode === 2" class="time-range" @click.stop>
              <el-time-picker
                v-model="startTime"
                class="time-input"
                :editable="false"
                :clearable="false"
                placeholder="开始时间"
                format="HH:mm"
                value-format="HH:mm"
                :picker-options="{ selectableRange: '00:00:00 - 23:59:59', format: 'HH:mm' }">
              </el-time-picker>
              <span class="time-split">—</span>
              <el-time-picker
                v-model="endTime"
                class="time-input"
                :editable="false"
                :clearable="false"
                placeholder="结束时间"
                format="HH:mm"
                value-format="HH:mm"
                :picker-options="{ selectableRange: '00:00:00 - 23:59:59', format: 'HH:mm' }">
              </el-time-picker>
            </div>
          </div>
          <div class="option-radio">
            <span class="radio-icon" :class="{ checked: mode === item.value }"></span>
          </div>
        </div>
      </div>
      <div slot="footer" class="footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="confirm">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import req from '@/utils/request'
export default {
  name: 'OnlineSetting',
  data () {
    return {
      visible: false,
      doctorId: '',
      mode: 1,
      startTime: null,
      endTime: null,
      optionList: [
        { value: 1, title: '全天在线', desc: '每天 0:00-24:00 持续接诊' },
        { value: 2, title: '按时段在线', desc: '每天固定时段接诊' },
        { value: 3, title: '离线', desc: '不接诊' }
      ]
    }
  },
  methods: {
    open (info) {
      this.visible = true

      this.doctorId = info.doctorId
      this.startTime = info.startTime
      this.endTime = info.endTime

      if (![null, undefined, ''].includes(info.startTime) && ![null, undefined, ''].includes(info.endTime)) {
        if (info.startTime == '00:00' && info.endTime == '24:00') {
          this.mode = 1
        } else {
          this.mode = 2
        }
      } else {
        this.mode = 3
      }
    },
    close () {
      this.visible = false
    },
    modeChange (value) {
      if (value === this.mode) {
        return
      }
      this.mode = value
      if (value === 1) {
        this.startTime = '00:00'
        this.endTime = '24:00'
      } else {
        this.startTime = null
        this.endTime = null
      }
    },
    async confirm () {
      function timeToSeconds(timeStr) {
        if ([null, undefined, ''].includes(timeStr)) {
          return null
        }
        const [hours, minutes] = timeStr.split(':').map(Number);
        return hours * 3600 + minutes * 60;
      }

      if (this.mode === 2) {
        if ([null, undefined, ''].includes(this.startTime)) {
          this.$message.error('请选择开始时间')
          return
        }
        if ([null, undefined, ''].includes(this.endTime)) {
          this.$message.error('请选择结束时间')
          return
        }
        if (this.startTime >= this.endTime) {
          this.$message.error('开始时间不能大于结束时间')
          return
        }
      }
      const res = await req.put('/patient/doctor/onlineTime', {
        doctorId: this.doctorId,
        startTime: timeToSeconds(this.startTime),
        endTime: timeToSeconds(this.endTime)
      })
      if (res.code === 200) {
        this.$message.success('保存成功')
        this.close()
        this.$emit('confirm')
      } else {
        this.$message.error(res.message)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.onlineSetting /deep/ .el-dialog__header {
  padding: 12px 16px;
}

.onlineSetting /deep/ .el-dialog__title {
  line-height: 24px;
  font-weight: 600;
  font-size: 16px;
  color: #000000;
}

.onlineSetting /deep/ .el-dialog__headerbtn {
  top: 16px;
  right: 20px;
}

.onlineSetting /deep/ .el-dialog__body {
  padding: 0;
}

.onlineSetting /deep/ .el-dialog__footer {
  padding: 0;
}

.content {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
}

.option-card {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  border-radius: 8px;
  border: 1px solid #F0F2F5;
  background: #F7F8FA;
  cursor: pointer;
  transition: all 0.2s;
}

.option-card.active {
  background: #ECF5FF;
  border-color: #409EFF;
}

.option-body {
  flex: 1;
  min-width: 0;
}

.option-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  line-height: 22px;
}

.option-desc {
  margin-top: 2px;
  font-size: 12px;
  color: #909399;
  line-height: 20px;
}

.time-range {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.time-input {
  width: 120px;
}

.time-input /deep/ .el-input__inner {
  height: 32px;
  line-height: 32px;
  padding: 0 12px;
  font-size: 13px;
  border-radius: 4px;
  border-color: #DCDFE6;
  background: #fff;
}

.time-input /deep/ .el-input__prefix {
  display: none;
}

.time-split {
  margin: 0 8px;
  color: #C0C4CC;
  font-size: 14px;
}

.option-radio {
  flex-shrink: 0;
  margin-left: 12px;
}

.radio-icon {
  box-sizing: border-box;
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid #DCDFE6;
  background: #fff;
}

.radio-icon.checked {
  border: 5px solid #409EFF;
}

.footer {
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 16px 20px;
  width: 100%;
  border-top: 1px solid #E0E0E0;
}

.footer /deep/ .el-button {
  box-sizing: border-box;
  padding: 6px 14px;
  height: 32px;
}
</style>
